// extracted by mini-css-extract-plugin
module.exports = {"footerActions":"renameActionModal_footerActions__3zKTt","cancelButton":"renameActionModal_cancelButton__32Qbb","renameButton":"renameActionModal_renameButton__15QMp"};